// config
import * as http from 'utils/http';
import config from 'config';

const getCarriersUsersByCarrier = async (carrierId) => {
  const data = await http.get(
    `${config.BASE_ROUTE}v1/users/?carrier_id=${carrierId}&page_size=${100}`
  );
  return data;
};

export default getCarriersUsersByCarrier;
